import Vuex from 'vuex'
import Account from "@/store/modules/account";
import User from "@/store/modules/user"
import Company from "@/store/modules/company";
import Transaction from "@/store/modules/transaction";
import PaySystem from "@/store/modules/paysystem";
import Kkt from "@/store/modules/kkt";
import Dashboard from "@/store/modules/dashboard";
import Auth from "@/store/modules/auth"

const store = new Vuex.Store({
        state: {},
        mutations: {},
        actions: {},
        modules: {
            account: Account,
            company: Company,
            user: User,
            transaction: Transaction,
            paySystem: PaySystem,
            kkt: Kkt,
            dashboard: Dashboard,
            auth: Auth
        }
    })

export default store;